import React, { useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Box, ChoiceButton, Text, Tooltip } from '@stashinvest/ui';

import { SignUpStep } from 'stash/components/sign-up/SignUpScreenLayout';
import { openDialog } from 'stash/actions/dialog';

const mapDispatchToProps = (dispatch, ownProps) => ({
	onSubmit: (values) => {
		return dispatch(
			ownProps.patchHandler({
				investor_application: { ...values },
			})
		)
			.then(() => {
				ownProps.completeStep();
			})
			.catch((e) => {
				dispatch(
					openDialog('Looks like there was a problem. Please try again.', 'Try again')
				).then(() => {
					window.location.reload();
				});
			});
	},
});

export function SignUpInvestorProfileQuestion(props) {
	const { title, subtitle, tooltipText, questionKey, answer, answerOptions } = props;

	const [submitting, setSubmitting] = useState(false);

	function handleSubmit(values) {
		setSubmitting(true);
		props.onSubmit(values);
	}

	return (
		<SignUpStep className="pt-contentMedium">
			<Box maxWidth="28rem" width="100%">
				<Text.H1 size="3" mb="xxs">
					{title}
				</Text.H1>
				<Text mb="m">
					{subtitle} {tooltipText && <Tooltip label={tooltipText} />}
				</Text>
				{answerOptions.map((option) => {
					const isSelected = answer === option.key;

					return (
						<ChoiceButton
							maxWidth="28em"
							mt="0"
							mb="s"
							id={option.key}
							onClick={() => handleSubmit({ [questionKey]: option.key })}
							key={option.key}
							disabled={submitting}
							selected={isSelected}
						>
							<Text size="4" color="currentColor" align="left">
								{option.title}
							</Text>
						</ChoiceButton>
					);
				})}
			</Box>
		</SignUpStep>
	);
}

SignUpInvestorProfileQuestion.propTypes = {
	title: PropTypes.string,
	subtitle: PropTypes.string,
	tooltipText: PropTypes.string,
	questionKey: PropTypes.string,
	answer: PropTypes.string,
	answerOptions: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.string,
			title: PropTypes.string,
		})
	),
	onSubmit: PropTypes.func,
};

export default connect(null, mapDispatchToProps)(SignUpInvestorProfileQuestion);
